import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const itemgenRoutes = [
  {
    path: 'item-customization',
    name: 'item-customization',
    component: () => import('./views/ItemCustomizationView.vue'),
    meta: {
      requiredRole: ROLES.INSTRUCTOR,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.KC_TOOLS,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.customizeKC,
    },
  },
  {
    path: 'questions',
    name: 'questions',
    component: () => import('./views/QuestionsView.vue'),
    meta: { requiredRole: ROLES.SUPER_ADMIN },
  },
];
